import React from 'react';
import { Button } from '@innovationnorway/cl-react';
import DialogContainer from 'src/components/DialogContainer/DialogContainer';
import { SivaContractDetailDto } from 'src/api/v2';
import DialogActions from 'src/components/DialogActions/DialogActions';
import useCompanyContract from '../hooks/use-company-contract';
import { useNavigate } from 'react-router-dom';
import { IDEAS_AND_COMPANIES } from 'src/features/siva/routes';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string;
  contract: SivaContractDetailDto;
  isActive: boolean;
  deactivate: () => void;
};

const DeleteContractdialog: React.FC<Props> = ({ title, contract, isActive, deactivate }) => {
  const { deleteSivaContractMutation } = useCompanyContract(contract.numericId);

  const { t: tCommon } = useTranslation('common');
  const { t: tSiva } = useTranslation('siva');

  const navigate = useNavigate();

  const handleDelete = () => {
    deleteSivaContractMutation.mutateAsync(contract.numericId).then(() => {
      deactivate();
      navigate(IDEAS_AND_COMPANIES.BASE);
    });
  };

  return (
    <DialogContainer show={isActive} onClose={deactivate} title={title}>
      <p>{tSiva('ideasAndCompanies.delete.confirm', { contract: contract.name })}</p>
      <p>{tCommon('cannotBeUndone')}</p>
      <DialogActions>
        <Button
          type="button"
          onClick={() => handleDelete()}
          data-color={'danger' as const}
          loading={deleteSivaContractMutation.isLoading}
          disabled={deleteSivaContractMutation.isLoading}
        >
          {tCommon('delete')}
        </Button>
        <Button type="button" onClick={deactivate}>
          {tCommon('cancel')}
        </Button>
      </DialogActions>
    </DialogContainer>
  );
};

export default DeleteContractdialog;
